import styled from 'styled-components';

const DatePickerWrapper = styled('div')`
  position: relative;

  .react-datepicker-wrapper {
    position: absolute;
    top: 50px;
  }

  .react-datepicker__input-container {
    display: none;
  }
`;

export default DatePickerWrapper;
